import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import SideMenu from '../navbar/SideMenu';
import SideMenuBuhumuza from '../navbar/SideMenuGitega'; 
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  List, 
  ListItem, 
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack
} from '@mui/material';

import {
  ExpandLess,
  Search,
  Menu as MenuIcon,
  ExpandMore,
  LocationOn,
  TrendingUp,
  TrendingDown,
  Group
} from '@mui/icons-material';


const drawerWidth = 240;
const rightDrawerWidth = 280; 
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';


const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const RightDrawerWrapper = styled('div')(({ theme }) => ({
  width: rightDrawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0,
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)',
    },
  }
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ZoneRow = styled(TableRow)({
  backgroundColor: '#f8f8f8',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

const gitegaData = {
  title: "RÉPARTITION DE LA POPULATION DE LA COMMUNE DE GITEGA PAR ZONE ET COLLINE",
  province: {
    id: "1",
    name: "BUHUMUZA",
    commune: {
      id: "101",
      name: "GITEGA",
      total: 514822,
      zones: [
        {
          id: "10101",
          name: "BUHEVYI",
          total: 23868,
          collines: [
            { id: "10101101", name: "BUHORO", population: 6089 },
            { id: "10101102", name: "KANYONGA", population: 6184 },
            { id: "10101103", name: "RUKOBE", population: 4533 },
            { id: "10101104", name: "KAGOMA", population: 4366 },
            { id: "10101105", name: "RUTEGAMA", population: 2696 }
          ]
        },
        {
          id: "10102",
          name: "BUHINDA",
          total: 29179,
          collines: [
            { id: "10102101", name: "PENIYERE", population: 3916 },
            { id: "10102102", name: "GIHAMAGARA", population: 3073 },
            { id: "10102103", name: "RUHANZA", population: 5060 },
            { id: "10102104", name: "BUHINDA", population: 4659 },
            { id: "10102105", name: "KIBOGOYE", population: 3847 },
            { id: "10102106", name: "KIREMBA", population: 3512 },
            { id: "10102107", name: "KIRAMBI", population: 1610 },
            { id: "10102108", name: "KUGITEGA", population: 1701 },
            { id: "10102109", name: "MUGOMERA", population: 1801 }
          ]
        },
        {
          id: "10103",
          name: "GIHETA",
          total: 35911,
          collines: [
            { id: "10103101", name: "KIREMERA", population: 8207 },
            { id: "10103102", name: "MUREMERA", population: 4952 },
            { id: "10103103", name: "BIHORORO", population: 5856 },
            { id: "10103104", name: "KIBOGOYE", population: 4192 },
            { id: "10103105", name: "RUTEGAMA", population: 3518 },
            { id: "10103106", name: "GISURU", population: 4373 },
            { id: "10103107", name: "RUHANZA", population: 2642 },
            { id: "10103108", name: "KORANE", population: 2171 }
          ]
        },
        {
          id: "10104",
          name: "ITABA",
          total: 21742,
          collines: [
            { id: "10104101", name: "GISIKARA", population: 3481 },
            { id: "10104102", name: "KINYARUKO", population: 3158 },
            { id: "10104103", name: "KAREMBA", population: 3107 },
            { id: "10104104", name: "MUTANGA", population: 2921 },
            { id: "10104105", name: "MACU", population: 2528 },
            { id: "10104106", name: "BUTARE", population: 1593 },
            { id: "10104107", name: "KANYINYA", population: 1343 },
            { id: "10104108", name: "ITABA", population: 1589 },
            { id: "10104109", name: "NKIMA", population: 2022 }
          ]
        },
        {
          id: "10105",
          name: "KABANGA",
          total: 27223,
          collines: [
            { id: "10105101", name: "KIBIMBA", population: 6299 },
            { id: "10105102", name: "RWERU", population: 2837 },
            { id: "10105103", name: "GIHEHE", population: 3718 },
            { id: "10105104", name: "GIHUGA", population: 2516 },
            { id: "10105105", name: "KAGUHU", population: 2749 },
            { id: "10105106", name: "MUYANGE", population: 2294 },
            { id: "10105107", name: "NYAMUGARI", population: 2760 },
            { id: "10105108", name: "MUSAMA", population: 2139 },
            { id: "10105109", name: "MURAYI", population: 1911 }
          ]
        },
        {
          id: "10106",
          name: "KIRIBA",
          total: 20844,
          collines: [
            { id: "10106101", name: "KIBANDE", population: 3879 },
            { id: "10106102", name: "GASUNU", population: 4102 },
            { id: "10106103", name: "MASASU", population: 2306 },
            { id: "10106104", name: "RWINGIRI", population: 2416 },
            { id: "10106105", name: "RUBARASI", population: 2177 },
            { id: "10106106", name: "KAMONYI", population: 1696 },
            { id: "10106107", name: "GISHUHA", population: 1232 },
            { id: "10106108", name: "KIRIBA", population: 2126 },
            { id: "10106109", name: "GISARARA", population: 910 }
          ]
        },
        {
          id: "10107",
          name: "MAKEBUKO",
          total: 19733,
          collines: [
            { id: "10107101", name: "MAVUVU", population: 3490 },
            { id: "10107102", name: "NGUNDU", population: 2723 },
            { id: "10107103", name: "MAKEBUKO", population: 2370 },
            { id: "10107104", name: "GASASA", population: 2353 },
            { id: "10107105", name: "RWANDA", population: 2351 },
            { id: "10107106", name: "NTITA", population: 1538 },
            { id: "10107107", name: "RWESERO", population: 1945 },
            { id: "10107108", name: "BUGUMBASHA", population: 2134 },
            { id: "10107109", name: "KAGEGE", population: 829 }
          ]
        },
        {
          id: "10108",
          name: "MARAMVYA",
          total: 34938,
          collines: [
            { id: "10108101", name: "BUGA", population: 4342 },
            { id: "10108102", name: "KIYANGE", population: 4388 },
            { id: "10108103", name: "JANJA", population: 4384 },
            { id: "10108104", name: "MUYANGE", population: 3999 },
            { id: "10108105", name: "KAROBA", population: 3534 },
            { id: "10108106", name: "RUSAGARA", population: 3640 },
            { id: "10108107", name: "MURAGO", population: 3306 },
            { id: "10108108", name: "MUSAVE", population: 2349 },
            { id: "10108109", name: "SIMBA", population: 2833 },
            { id: "10108110", name: "RWEZAMENYO", population: 2163 }
          ]
        },
        {
          id: "10109",
          name: "MARIZA",
          total: 8053,
          collines: [
            { id: "10109101", name: "MITIMIRE", population: 1691 },
            { id: "10109102", name: "NYARUNAZI", population: 1963 },
            { id: "10109103", name: "BUKINGA", population: 1601 },
            { id: "10109104", name: "MUBUGA", population: 1646 },
            { id: "10109105", name: "KANYINYA", population: 1152 }
          ]
        },
        {
          id: "10110",
          name: "MUBUGA",
          total: 36739,
          collines: [
            { id: "10110101", name: "MUBUGA", population: 6857 },
            { id: "10110102", name: "MIRAMA", population: 5730 },
            { id: "10110103", name: "MURIRWE", population: 4785 },
            { id: "10110104", name: "MUKANDA", population: 4424 },
            { id: "10110105", name: "KIMANAMA", population: 5611 },
            { id: "10110106", name: "BUKWAZO", population: 3637 },
            { id: "10110107", name: "NGOBEKE", population: 3507 },
            { id: "10110108", name: "KARENDA", population: 2188 }
          ]
        },
        {
          id: "10111",
          name: "MUNGWA",
          total: 67642,
          collines: [
            { id: "10111101", name: "KARERA", population: 11115 },
            { id: "10111102", name: "NTOBWE", population: 12082 },
            { id: "10111103", name: "RUTOKE", population: 7567 },
            { id: "10111104", name: "MUGOBOKA", population: 6261 },
            { id: "10111105", name: "JIMBI", population: 5803 },
            { id: "10111106", name: "BUTAMUHEBA", population: 5581 },
            { id: "10111107", name: "BIHANGA", population: 4464 },
            { id: "10111108", name: "KIBIRI", population: 4814 },
            { id: "10111109", name: "MUNGWA", population: 5424 },
            { id: "10111110", name: "RWEZA", population: 4531 }
          ]
        },
        {
          id: "10112",
          name: "MURENDA",
          total: 24412,
          collines: [
            { id: "10112101", name: "RUTANGANIKA", population: 5308 },
            { id: "10112102", name: "GASAGARA", population: 3119 },
            { id: "10112103", name: "MURENDA", population: 3271 },
            { id: "10112104", name: "MWANZARI", population: 2862 },
            { id: "10112105", name: "MUHORORO", population: 2291 },
            { id: "10112106", name: "MWUMBA", population: 2512 },
            { id: "10112107", name: "NYAMAGANDIKA", population: 1927 },
            { id: "10112108", name: "GASENYI", population: 1446 },
            { id: "10112109", name: "BUTOBWE", population: 1676 }
          ]
        },
        {
          id: "10113",
          name: "NYAMUGARI",
          total: 84046,
          collines: [
            { id: "10113101", name: "YOBA", population: 13228 },
            { id: "10113102", name: "NYAMUGARI", population: 11065 },
            { id: "10113103", name: "MAGARAMA", population: 10960 },
            { id: "10113104", name: "NYABISINDU", population: 6808 },
            { id: "10113105", name: "NYABUTUTSI", population: 11957 },
            { id: "10113106", name: "RANGO", population: 5751 },
            { id: "10113107", name: "MUSAVE", population: 6158 },
            { id: "10113108", name: "MUSHASHA", population: 4775 },
            { id: "10113109", name: "BWOGA", population: 8102 },
            { id: "10113110", name: "SHATANYA", population: 2619 },
            { id: "10113111", name: "MUSINZIRA", population: 2623 }
          ]
        },
        {
          id: "10114",
          name: "RUTEGAMA",
          total: 80492,
          collines: [
            { id: "10114101", name: "RUTEGAMA", population: 13303 },
            { id: "10114102", name: "ZEGE", population: 7905 },
            { id: "10114103", name: "BIROHE", population: 10685 },
            { id: "10114104", name: "CERU", population: 2709 },
            { id: "10114105", name: "SONGA", population: 9731 },
            { id: "10114106", name: "RUBAMVYI", population: 6677 },
            { id: "10114107", name: "HIGIRO", population: 6134 },
            { id: "10114108", name: "MUGUTU", population: 5459 },
            { id: "10114109", name: "NYAKIBINGO", population: 4896 },
            { id: "10114110", name: "RUKOBA", population: 4970 },
            { id: "10114111", name: "MAHONDA", population: 4115 },
            { id: "10114112", name: "GITAMO", population: 2177 },
            { id: "10114113", name: "RUBARASI", population: 1731 }
          ]
        }
      ]
    }
  }
};

const PopulationDataPageGitegaGitega = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const [expandedZones, setExpandedZones] = useState({});
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRightDrawerToggle = () => {
    setMobileRightOpen(!mobileRightOpen);
  };

  const toggleZone = (zoneId) => {
    setExpandedZones(prev => ({
      ...prev,
      [zoneId]: !prev[zoneId]
    }));
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    const filteredZones = data.province.commune.zones.map(zone => {
      const filteredCollines = zone.collines.filter(colline =>
        colline.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      return {
        ...zone,
        collines: filteredCollines,
        show: filteredCollines.length > 0 || 
              zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      };
    }).filter(zone => zone.show || !searchTerm);
    
    return {
      ...data,
      province: {
        ...data.province,
        commune: {
          ...data.province.commune,
          zones: filteredZones
        }
      }
    };
  };

  const filteredData = filterData(gitegaData, searchTerm);

  const keyStats = useMemo(() => {
    const commune = gitegaData.province.commune;
    
    const mostPopulatedZone = commune.zones.reduce((max, zone) => 
      zone.total > max.total ? zone : max, commune.zones[0]);
    
    const leastPopulatedZone = commune.zones.reduce((min, zone) => 
      zone.total < min.total ? zone : min, commune.zones[0]);
    
    const mostPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((max, colline) => colline.population > max.population ? colline : max, commune.zones[0].collines[0]);
    
    const leastPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((min, colline) => colline.population < min.population ? colline : min, commune.zones[0].collines[0]);

    const zonePercentages = commune.zones.map(zone => ({
      ...zone,
      percentage: ((zone.total / commune.total) * 100).toFixed(1)
    }));
    
    return {
      totalPopulation: commune.total.toLocaleString(),
      totalZones: commune.zones.length,
      totalCollines: commune.zones.reduce((sum, zone) => sum + zone.collines.length, 0),
      mostPopulatedZone,
      leastPopulatedZone,
      mostPopulatedColline,
      leastPopulatedColline,
      zonePercentages,
      communeTotal: commune.total
    };
  }, []);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            <SideMenu /> 
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            <SideMenu />
          </Drawer>
        )}

       
        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
                <Button 
                  variant="outlined" 
                  endIcon={<MenuIcon />} 
                  onClick={handleRightDrawerToggle}
                  sx={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  Info GITEGA
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="body1" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {gitegaData.title}
                    </Typography>
                    <Chip 
                      icon={<Group />} 
                      label={`Commune de GITEGA`} 
                      color="primary" 
                      variant="outlined" 
                    />
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher zone/colline..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '400px' } }}
                      />
                    </Grid>
                  </Grid>
                
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                         Commune de GITEGA
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Totale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Zones
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="secondary">
                                {keyStats.totalZones}
                              </Typography>
                              <Typography variant="caption">
                                Zones répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Collines
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalCollines}
                              </Typography>
                              <Typography variant="caption">
                                Collines répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.mostPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.leastPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.leastPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.mostPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.leastPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>

                     
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                          Répartition de la population par zone
                        </Typography>
                        {keyStats.zonePercentages.map((zone) => (
                          <Box key={zone.id} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="body2">
                                {zone.name}
                              </Typography>
                              <Typography variant="body2" fontWeight="bold">
                                {zone.percentage}% ({zone.total.toLocaleString()})
                              </Typography>
                            </Box>
                            <LinearProgress 
                              variant="determinate" 
                              value={zone.percentage} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: zone.id === keyStats.mostPopulatedZone.id ? primaryColor : 
                                                zone.id === keyStats.leastPopulatedZone.id ? secondaryColor : '#888',
                                }
                              }} 
                            />
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Zone/Colline</TableCell>
                          <TableCell align="right">Population</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredData.province.commune.zones.map((zone) => (
                          <React.Fragment key={zone.id}>
                            <ZoneRow 
                              hover 
                              onClick={() => toggleZone(zone.id)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row" colSpan={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedZones[zone.id] ? <ExpandLess /> : <ExpandMore />}
                                  <LocationOn sx={{ mr: 1, color: primaryColor }} />
                                  {zone.name}
                                </Box>
                              </TableCell>
                            </ZoneRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={2}>
                                <Collapse in={expandedZones[zone.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {zone.collines.map((colline) => (
                                        <TableRow key={colline.id} hover>
                                          <TableCell sx={{ pl: 4 }}>{colline.name}</TableCell>
                                          <TableCell align="right">{colline.population.toLocaleString()}</TableCell>
                                        </TableRow>
                                      ))}
                                      <TableRow>
                                        <TableCell sx={{ pl: 4, fontWeight: 'bold' }}>Total {zone.name}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{zone.total.toLocaleString()}</TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                        <TableRow sx={{ backgroundColor: '#e0e0e0', fontWeight: 'bold' }}>
                          <TableCell>TOTAL COMMUNE DE GITEGA</TableCell>
                          <TableCell align="right">{gitegaData.province.commune.total.toLocaleString()}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Paper>
                
               
               
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative - Commune de GITEGA
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La commune de GITEGA est divisée en {keyStats.totalZones} zones administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {keyStats.zonePercentages.map((zone, index) => (
                        <ListItem key={zone.id}>
                          <ListItemText 
                            primary={`${index + 1}. ${zone.name}`} 
                            secondary={`Population: ${zone.total.toLocaleString()} habitants (${zone.percentage}%) - ${zone.collines.length} collines`} 
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                
              
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population. 
                    Les chiffres incluent uniquement la population des ménages ordinaires.
                    Les pourcentages sont calculés par rapport à la population totale de la commune de GITEGA ({keyStats.totalPopulation} habitants).
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>

        
        {!isMobile ? (
          <RightDrawerWrapper>
            <SideMenuBuhumuza />
          </RightDrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileRightOpen}
            onClose={handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: rightDrawerWidth },
            }}
          >
            <SideMenuBuhumuza /> 
          </Drawer>
        )}
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageGitegaGitega;